module.exports = __webpack_public_path__ + "static/media/sticks_and_stars.fd52ebe4.svg";